/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import PropTypes from 'prop-types';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export function RenderBinaryPdf({ data }) {
  return (
    <div className="renderPdf">
      {data && <iframe src={data} className="iframe" />}
    </div>
  );
}

RenderBinaryPdf.propTypes = {
  data: PropTypes.string.isRequired,
};
